import { assign } from 'xstate5';

import { getOrderDetails } from '../../helpers';
import { type ReorderEventParams, type ReorderMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const storeOrderDetails: ReorderMachineAction<ReorderEventParams> = assign(
  ({ context }, params) => getOrderDetails(context, params.reorderEvent),
);
